import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 40px 20px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  margin-bottom: 30px;
`;

export const BreadcrumbNav = styled.div`
  font-size: 13px;
  color: #666;
  margin-bottom: 15px;
`;

export const BreadcrumbLink = styled.span`
  color: #2f2f2f;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const PageTitle = styled.h1`
  font-size: 28px;
  color: #333;
  margin: 0;
  text-align: center;
`;

export const GestacaoSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;

  label {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  select {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    background: white;
    cursor: pointer;
  }
`;

export const TableContainer = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`;

export const VacinasTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  thead {
    background-color: #f5f5f5;
    border-bottom: 2px solid #ddd;
  }

  th {
    padding: 15px;
    text-align: left;
    font-weight: 600;
    color: #333;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  td {
    padding: 15px;
    border-bottom: 1px solid #eee;
    vertical-align: middle;
  }

  tbody tr:hover {
    background-color: #f9f9f9;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const VacinaNome = styled.span`
  font-weight: 600;
  color: #333;
  font-size: 14px;
`;

export const DosesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const DoseBadge = styled.span`
  display: inline-block;
  background-color: ${props => {
    if (props.$status === 'tomada') return '#595959';
    if (props.$status === 'nao-tomada') return '#1a1a1a';
    if (props.$status === 'incompleta') return '#8a8a8a';
    return '#6c757d';
  }};
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

export const SituacaoBadge = styled.span`
  display: inline-block;
  background-color: ${props => {
    if (props.$status === 'completa') return '#595959';
    if (props.$status === 'incompleta') return '#1a1a1a';
    return '#6c757d';
  }};
  color: white;
  padding: 6px 12px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

export const JustificativaText = styled.span`
  font-size: 13px;
  color: #666;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;

export const PaginationButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #333;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: #f5f5f5;
    border-color: #999;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PageInfo = styled.span`
  font-size: 13px;
  color: #666;
  margin: 0 10px;
`;

export const EditIcon = styled.button`
  background: none;
  border: none;
  color: #2f2f2f;
  cursor: pointer;
  font-size: 18px;
  padding: 4px 8px;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #1a1a1a;
  }

  &:disabled {
    color: #b3b3b3;
    cursor: not-allowed;
  }

  &:disabled:hover {
    color: #b3b3b3;
  }
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 40px 20px;
  font-size: 16px;
  color: #666;
`;

export const ErrorContainer = styled.div`
  background: #dee2e6;
  border: 1px solid #8a8a8a;
  color: #1a1a1a;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
`;
